var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessiconcomponent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success icon component"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 9",
    d: "M100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 22.3858 22.3858 0 50 0C77.6142 0 100 22.3858 100 50ZM4.67517 50C4.67517 75.0322 24.9678 95.3248 50 95.3248C75.0322 95.3248 95.3248 75.0322 95.3248 50C95.3248 24.9678 75.0322 4.67517 50 4.67517C24.9678 4.67517 4.67517 24.9678 4.67517 50Z",
    fill: "#00A91B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.9881 33.4902L42.991 64.4873L28.9014 50.3977",
    stroke: "url(#paint0_linear_1603_17835)",
    strokeWidth: 7.10983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1603_17835",
    x1: 26.5892,
    y1: 49.1333,
    x2: 47.6875,
    y2: 56.9368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A91B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A91B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessiconcomponent);
export default __webpack_public_path__ + "static/media/success icon component.d3620334506617ad247c9a09cb1ffaed.svg";
export { ForwardRef as ReactComponent };